import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

/**
 * 登录态统一读写（全项目共用）：
 * 勾选“记住我”→ token 存 localStorage（7 天持久，关浏览器仍登录）
 * 未勾选 → token 存 sessionStorage（关标签/浏览器即失效）
 * 任何地方读 token 都优先 localStorage、兜底 sessionStorage，保证两种登录态下功能一致。
 */
export function getAccessToken () {
  return Vue.ls.get(ACCESS_TOKEN) || sessionStorage.getItem(ACCESS_TOKEN)
}

export function removeAccessToken () {
  Vue.ls.remove(ACCESS_TOKEN)
  sessionStorage.removeItem(ACCESS_TOKEN)
}
